import React, { useState, useEffect } from "react";

import contentfulApi from "../utils/contentful";
import formatText from "../utils/formatText";
import {
  callToLearnMoreButtonClicked,
  downloadOnAppStoreClicked,
} from "utils/segment";

import Container from "./Container";
import Row from "./Row";
import Col from "./Col";
import Button from "./Button";
import { ApplyNowButton } from "./ApplyNowButton";

const HowTheAppWorks = ({ page, hideAppLinks, applicationRef }) => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    function getEntryId() {
      switch (page) {
        case "becomeAPal":
          return "1SM7jgk96GIqxs2sGTdSyI";
        case "virtualVisits":
          return "1da5GN6XsLSSjH9d0WjbUi";
        default:
          return "32DPiZTSlb1IdLf8dprbGe";
      }
    }

    contentfulApi.getEntry(getEntryId()).then((response) => {
      setData(Object.assign(response.fields));
      setDataLoaded(true);
    });
  }, [page]);

  if (!dataLoaded) {
    return null;
  }

  function renderTitle() {
    switch (page) {
      case "becomeAPal":
      case "virtualVisits":
        return "Pal App";
      default:
        return "Member App";
    }
  }

  function renderAppButtons() {
    if (hideAppLinks) return null;

    return (
      <div className="flex align-center justify-center">
        <a
          href="https://apps.apple.com/us/app/papa-pal/id1498631076"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            downloadOnAppStoreClicked({ appStore: "App Store" });
          }}
        >
          <img
            data-src={data.appStore.fields.file.url + "?w=140"}
            alt="App Store"
            className="appstore mr-30 lazyload"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.joinpapa.papapal"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            downloadOnAppStoreClicked({ appStore: "Google Play" });
          }}
        >
          <img
            data-src={data.playStore.fields.file.url + "?w=200"}
            alt="Play Store"
            className="playstore lazyload"
          />
        </a>
      </div>
    );
  }

  function renderCTAs() {
    if (page === "becomeAPal") {
      return (
      <ApplyNowButton
        className="HowTheAppWorks" 
        siteDivName="BecomeAPal"
        applicationRef={applicationRef}
      />
      );
    }

    if (page === "virtualVisits") {
      return (
        <Button
          href="tel:+1-800-348-7951"
          onClick={callToLearnMoreButtonClicked}
        >
          <span className="hidden-mobile">Call to learn more</span>{" "}
          1-800-348-7951
        </Button>
      );
    } else{
      return renderAppButtons();
    }
  }

  return (
    <div className="how-the-app-works">
      <Container>
        <div className="section-headings text-center">
          <h3 className="mb-20 hidden-desktop">{renderTitle()}</h3>

          <h3 className="mb-20 hidden-mobile">{data.heading}</h3>
          <p className="mr-auto ml-auto">{data.subheading}</p>
        </div>

        <Row>
          {page === "virtualVisits" ? (
            <Col md={{ span: 8, offset: 2 }} className="text-center">
              <img
                src={data.image.fields.file.url + "?w=520"}
                alt="Papa Apps"
                className="img-responsive mr-auto ml-auto mb-30"
              />

              {renderCTAs()}
            </Col>
          ) : (
            <>
              <Col md={6}>
                <img
                  data-src={data.image.fields.file.url + "?w=520&q=80"}
                  alt="Papa Apps"
                  className="img-responsive mr-auto ml-auto mb-30 devices lazyload"
                />

                {page === "becomeAPal" ? (
                  renderAppButtons()
                ) : (
                  <div className="hidden-desktop">{renderAppButtons()}</div>
                )}
              </Col>

              <Col
                md={6}
                className="flex direction-column justify-center hidden-mobile"
              >
                <div className="steps">
                  {data.steps.map((step, index) => (
                    <p
                      key={`step_${index}`}
                      dangerouslySetInnerHTML={{
                        __html: formatText(step),
                      }}
                    />
                  ))}

                  {renderCTAs()}
                </div>
              </Col>
            </>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default HowTheAppWorks;
